import React from "react";
import PdfViewer from "../../PdfViewer";

const PolizaKNetworking2026 = () => {
  const pdfUrl = `${process.env.REACT_APP_BUCKET}/pdf/polizas/110526-Poliza-de-Servicios_K-Networking_X440_24P-5320-24P.pdf`;
  /*const pdfUrl = "/pdf/110526-Poliza-de-Servicios_K-Networking_X440_24P-5320-24P.pdf";*/

  console.log("PDF URL:", pdfUrl);

  return (
    <>
      <main>
        <div class="titulo">
          <h1>Póliza 2026</h1>
        </div>
        <div className="pdf-container">
          <PdfViewer pdfUrl={pdfUrl} />
        </div>
      </main>
    </>
  );
};

 export default PolizaKNetworking2026;
